import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

/**
 * @deprecated because of default Query Params from Angular
 */
@Injectable({
  providedIn: "root"
})
export class DirectUrlEncodeInterceptor implements HttpInterceptor {
  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    if (req.params.keys().length) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        url: encodeURI(req.urlWithParams),
        params: new HttpParams()
      })
    );
  }
}
